import { RulesetData } from '@domain/rules/Ruleset';
import { DomainModelData, DomainModelsData } from '../composition/composition';
import { DataSource } from './DataSource';

// FIXME -> Quick fix porque no deja hacer imports fuera de la carpeta, mirar de importar el fichero con readFile?
export interface SubfamilyData {
    name: string
    related: Array<{ model: string, applicationsLocations: number[] }>
}

export default class DataProvider {
    static async getInformationByModel(dataSource: DataSource, model: string, catalog: number | string = '16', isComplement: boolean = false): Promise<DomainModelData> {
        try {
            const subfamilyData = await dataSource.getSubfamilyDataByModel(model, catalog, isComplement)
            await this.addSubfamilyRules(dataSource, subfamilyData, String(subfamilyData[model].subfamily))
            return subfamilyData[model]
        } catch (err) {
            throw err
        }
    }

    static async getInformationByReference(dataSource: DataSource, reference: string): Promise<DomainModelData> {
        // if (reference.length < 9) throw `Cannot interpret reference ${reference}`
        // TEST -> Productos con referencia de 6 digitos -> p.ej JAZZ (133010)
        try {
            const model = reference.slice(0, 4)
            const catalog = reference.includes('-') ? 21 : 16
            return this.getInformationByModel(dataSource, model, catalog)
        } catch (err) {
            throw err
        }
    }

    static async getInformationBySubFamilyName(dataSource: DataSource, subfamilyName: string, catalog: string = '16'): Promise<DomainModelsData> {
        try {
            return await dataSource.getSubfamilyDataByName(subfamilyName, catalog)
        } catch (err) {
            throw err
        }
    }

    static async getInformationBySubFamilyId(dataSource: DataSource, subfamilyId: number | string, catalog: number | string = '16'): Promise<DomainModelsData> {
        try {
            const subfamilyData = await dataSource.getSubfamilyDataById(subfamilyId, catalog)
            await this.addSubfamilyRules(dataSource, subfamilyData, String(subfamilyId))
            return subfamilyData      
        } catch (err) {
            throw err
        }
    }

    static async getInformationBySubFamilyIdWithAccessories(dataSource: DataSource, subfamilyId: number | string, catalog: number | string = '16'): Promise<DomainModelsData> {
        try {
            return await dataSource.getInformationBySubFamilyIdWithAccessories(subfamilyId, catalog)
        } catch (err) {
            throw err
        }
    }
    
    static async addSubfamilyRules(dataSource: DataSource, subfamilyData: DomainModelsData, subfamilyId: string) {
        try {
            const subFamilyRules = await dataSource.getDataRulesBySubfamilyName(subfamilyId);
            Object.keys(subfamilyData).forEach((modelId) => {
                const modelIdString = String(modelId)
                subfamilyData[modelIdString].rules = subfamilyData[modelIdString].rules.concat(subFamilyRules.rules)
            })
        } catch (e) {
            console.error(`Imposible to add rules to subfamily ${subfamilyId}`)
        }
    }
    
    static async getAccessoriesInformationBySubFamilyId(dataSource: DataSource, subfamilyId: number | string, catalog: number | string = '16'): Promise<DomainModelsData> {
        try {
            return await dataSource.getSubfamilyAccesoriesDataById(subfamilyId, catalog)
        } catch (err) {
            throw err
        }
    }

    static async getRulesInformationBySubFamilyId(dataSource: DataSource, subfamilyId: number | string): Promise<RulesetData> {
        try {
            return await dataSource.getDataRulesBySubfamilyName(subfamilyId)
        } catch (err) {
            throw err
        }
    }

    static async getSubfamilies(dataSource: DataSource): Promise<{ [key: string]: SubfamilyData }> {
        try {
            return await dataSource.getSubfamilies()
        } catch (err) {
            throw err
        }
    }
}